// Check for file accessibility - handle files opened in other applications
export const checkFileAccess = async (file: File): Promise<boolean> => {
  try {
    // For empty files, check if it's intentionally empty or potentially locked
    const slice = file.slice(0, 1024);
    await slice.arrayBuffer();

    const filename = file.name;
    const extension = filename.split(".").pop()?.toLowerCase();

    // For common file types that shouldn't be empty, we'll check for locks
    // Excel and other office files should never be 0 bytes when valid
    const likelyLockedExtensions = ["xlsx", "xls", "csv", "doc", "docx", "ppt", "pptx", "pdf"];

    if (likelyLockedExtensions.includes(extension)) {
      console.log("File is empty, checking for locks:", filename);
      // Try to read a slice of the file to see if it's accessible
      // If the file is locked this should fail most likely
      try {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file.slice(0, 1));
        const result: boolean = await new Promise((resolve) => {
          reader.onload = () => {
            resolve(true);
          };
          reader.onerror = () => {
            resolve(false);
          };
        });
        console.log("File access check result:", result);
        return result;
      } catch (error) {
        return false;
      }
    }

    // For other extensions, we'll allow empty files
    return true;
  } catch (error) {
    return false;
  }
};
